(function () {
  var container = document.getElementById('AllAuthors');
  if (!container) return;

  var grid = container.querySelector('.all-authors__grid');
  var sortButtons = container.querySelectorAll('.all-authors__sort-btn');
  var filterChips = container.querySelectorAll('.all-authors__filter-chip');
  var emptyState = container.querySelector('.all-authors__empty');
  var nameFilterInput = document.getElementById('AllAuthorsNameFilter');
  var countEl = container.querySelector('.all-authors__count');
  var summaryEl = container.querySelector('[data-authors-summary]');

  if (!grid) return;

  function getCards() {
    return Array.prototype.slice.call(grid.querySelectorAll('.author-card'));
  }

  // Original DOM order (reassigned after the client re-render). ssrCount = the no-JS
  // baseline card count, used by the fail-soft guard.
  var originalOrder = getCards();
  var ssrCount = originalOrder.length;
  var nameQuery = '';

  function updateEmptyState() {
    var visibleCount = 0;
    getCards().forEach(function (card) {
      if (card.style.display !== 'none') visibleCount++;
    });
    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? '' : 'none';
    }
  }

  function updateSummary() {
    var cards = getCards();
    var total = cards.length;
    var visible = cards.filter(function (c) { return c.style.display !== 'none'; }).length;
    var txt = total + (total === 1 ? ' author' : ' authors');
    if (visible !== total) txt += ' · ' + visible + ' shown';
    if (countEl) countEl.textContent = txt;
    if (summaryEl) summaryEl.textContent = visible + ' of ' + total + ' authors shown';
  }

  // ── Data-driven render from search-index.json ───────────────────────────
  // The FULL author directory is cloned from a dedicated hidden <template> (no
  // render-time pages[] lookup, no section-block cap). The SSR ≤48-card baseline is
  // the no-JS/crawler fallback and is REPLACED only on a successful fetch.

  var cardTpl = document.getElementById('author-card-template');
  var chipTpl = document.getElementById('author-chip-template');
  var authorsSrc = container.getAttribute('data-authors-src');
  var placeholderSrc = container.getAttribute('data-placeholder-src') || '';

  function safeLink(au) {
    var lnk = au.lnk || ('/pages/' + (au.h || ''));
    // Only site-relative or https (a javascript:/data: value → fall back).
    if (lnk.charAt(0) === '/' || lnk.indexOf('https://') === 0) return lnk;
    return '/pages/' + (au.h || '');
  }

  function buildCard(au) {
    var node = cardTpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-author-name', au.n || '');
    node.setAttribute('data-product-count', String(au.c || 0));
    node.setAttribute('data-categories', au.at || '');
    node.setAttribute('data-featured', au.f ? 'true' : 'false');
    node.setAttribute('data-author-handle', au.h || '');

    var link = node.querySelector('.author-card__link');
    if (link) link.setAttribute('href', safeLink(au));

    // The template <img> carries NO srcset — set src (width=240) or the placeholder,
    // so a cloned card never renders the wrong headshot at 2x.
    var img = node.querySelector('.author-card__headshot img');
    if (img) {
      img.setAttribute('src', au.i || placeholderSrc);
      img.setAttribute('alt', au.n || '');
    }

    var nameEl = node.querySelector('.author-card__name');
    if (nameEl) nameEl.textContent = au.n || '';

    var c = au.c || 0;
    var countNode = node.querySelector('.author-card__count');
    if (countNode) countNode.textContent = c + (c === 1 ? ' Program' : ' Programs');

    var tagsWrap = node.querySelector('.author-card__tags');
    if (tagsWrap && chipTpl && Array.isArray(au.td)) {
      au.td.slice(0, 3).forEach(function (t) {
        var chip = chipTpl.content.firstElementChild.cloneNode(true);
        chip.textContent = t; // pre-transformed display text (tag-chip parity, build-time)
        tagsWrap.appendChild(chip);
      });
    }
    return node;
  }

  function renderFromAsset() {
    if (!authorsSrc || !cardTpl || !chipTpl) return; // keep the SSR baseline
    fetch(authorsSrc)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var arr = data && Array.isArray(data.authors) ? data.authors : null;
        // Fail-soft (explicit): replace the grid ONLY when the parsed set is valid and
        // at least the SSR baseline size; else keep the SSR cards (never a blank grid).
        if (!arr || arr.length < ssrCount) {
          console.warn('[all-authors] asset fetch/shape failure — SSR fallback');
          return;
        }
        var sorted = arr.slice().sort(function (a, b) {
          var fa = a.f ? 1 : 0, fb = b.f ? 1 : 0;
          if (fa !== fb) return fb - fa;                 // featured first
          var ca = a.c || 0, cb = b.c || 0;
          if (cb !== ca) return cb - ca;                 // then product count desc
          return (a.n || '').localeCompare(b.n || '');   // then name
        });
        var frag = document.createDocumentFragment();
        sorted.forEach(function (au) { frag.appendChild(buildCard(au)); });

        // Replace the SSR cards; preserve the empty-state node.
        getCards().forEach(function (card) { grid.removeChild(card); });
        grid.insertBefore(frag, emptyState || null);

        // Re-init closure state after the wholesale replace — else 'featured' would
        // re-append the DETACHED SSR nodes → duplicate cards + a broken default view.
        originalOrder = getCards();
        applyFilter();
      })
      .catch(function () {
        console.warn('[all-authors] asset fetch/shape failure — SSR fallback');
      });
  }

  // ── Best-selling author scores (fetched once, cached) ────────────────

  var authorScores = null;
  var scoresFetched = false;

  function fetchBestSellingScores() {
    return fetch('/collections/all/products.json?sort_by=best-selling&limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var scores = {};
        (data.products || []).forEach(function (product, index) {
          var tags = (product.tags || '').split(', ');
          var authorTag = null;
          for (var i = 0; i < tags.length; i++) {
            if (tags[i].trim().indexOf('author-') === 0) {
              authorTag = tags[i].trim();
              break;
            }
          }
          if (authorTag) {
            var handle = authorTag.replace('author-', '');
            if (!scores[handle]) {
              scores[handle] = { bestRank: index, totalProducts: 0 };
            }
            scores[handle].totalProducts++;
          }
        });
        authorScores = scores;
        scoresFetched = true;
        return scores;
      });
  }

  // ── Sort ──────────────────────────────────────────────────────────────

  function reorderAndFilter(cards) {
    cards.forEach(function (card) { grid.appendChild(card); });
    if (emptyState) grid.appendChild(emptyState);
    applyFilter();
  }

  function sortByScores(cards) {
    cards.sort(function (a, b) {
      var scoreA = authorScores[a.dataset.authorHandle];
      var scoreB = authorScores[b.dataset.authorHandle];

      // Authors with sales data rank above those without
      if (!scoreA && !scoreB) return (a.dataset.authorName || '').localeCompare(b.dataset.authorName || '');
      if (!scoreA) return 1;
      if (!scoreB) return -1;

      // Primary: best rank (lower = more popular)
      if (scoreA.bestRank !== scoreB.bestRank) return scoreA.bestRank - scoreB.bestRank;

      // Tiebreak: total products in best-selling list
      if (scoreA.totalProducts !== scoreB.totalProducts) return scoreB.totalProducts - scoreA.totalProducts;

      return (a.dataset.authorName || '').localeCompare(b.dataset.authorName || '');
    });
    reorderAndFilter(cards);
  }

  function sortByProductCount(cards) {
    cards.sort(function (a, b) {
      var countA = parseInt(a.dataset.productCount, 10) || 0;
      var countB = parseInt(b.dataset.productCount, 10) || 0;
      if (countB !== countA) return countB - countA;
      return (a.dataset.authorName || '').localeCompare(b.dataset.authorName || '');
    });
    reorderAndFilter(cards);
  }

  function sortCards(mode) {
    if (mode === 'featured') {
      // Featured-first order, ALL cards VISIBLE (a sort, not a hide-to-~24 filter).
      originalOrder.forEach(function (card) { grid.appendChild(card); });
      if (emptyState) grid.appendChild(emptyState);
      applyFilter();
      return;
    }

    var cards = getCards();

    if (mode === 'az') {
      cards.sort(function (a, b) {
        return (a.dataset.authorName || '').localeCompare(b.dataset.authorName || '');
      });
      reorderAndFilter(cards);
      return;
    }

    // Most Popular: sort by best-selling sales data
    if (mode === 'popular') {
      if (scoresFetched) {
        sortByScores(cards);
      } else {
        fetchBestSellingScores()
          .then(function () { sortByScores(getCards()); })
          .catch(function () { sortByProductCount(getCards()); });
      }
    }
  }

  sortButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sortButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('active');
      });
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('active');
      sortCards(btn.dataset.sort);
    });
  });

  // ── Filter (category chips + name search) ───────────────────────────────

  var activeCategories = new Set();

  function applyFilter() {
    var cards = getCards();
    var nq = nameQuery.trim().toLowerCase();

    cards.forEach(function (card) {
      var catOk = true;
      if (activeCategories.size > 0) {
        var cardCats = (card.dataset.categories || '').split(',').map(function (c) {
          return c.trim();
        });
        catOk = false;
        activeCategories.forEach(function (cat) {
          if (cardCats.indexOf(cat) !== -1) catOk = true;
        });
      }

      var nameOk = !nq || (card.dataset.authorName || '').toLowerCase().indexOf(nq) !== -1;
      card.style.display = (catOk && nameOk) ? '' : 'none';
    });

    updateEmptyState();
    updateSummary();
  }

  filterChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = chip.dataset.category;
      if (activeCategories.has(cat)) {
        activeCategories.delete(cat);
        chip.setAttribute('aria-pressed', 'false');
        chip.classList.remove('active');
      } else {
        activeCategories.add(cat);
        chip.setAttribute('aria-pressed', 'true');
        chip.classList.add('active');
      }
      applyFilter();
    });
  });

  if (nameFilterInput) {
    nameFilterInput.addEventListener('input', function () {
      nameQuery = nameFilterInput.value || '';
      applyFilter();
    });
  }

  // Initial: show the SSR baseline (featured-first, all visible), then swap in the
  // full client-rendered set.
  applyFilter();
  renderFromAsset();
})();
